// extracted by mini-css-extract-plugin
export default {"root":"ThreadMediaFooter_root__Sj2CN","modifyEdited":"ThreadMediaFooter_modifyEdited__F+3qH","leftAlign":"ThreadMediaFooter_leftAlign__bfRqG"};